
















































































































































































































































import { Filter } from '@/interfaces/filter.interface'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

interface Pagination {
    currentPage: number;
    total: number;
    nextPage: boolean|null;
    previousPage: boolean|null;
    limit: number;
}

@Component
export default class SubscriptionHistory extends Vue {
    @Prop({ required: true }) getDateFormat!: (date: Date) => {};
    @Prop({ required: true }) refreshTrigger!: boolean
    @Prop({ required: false }) providerId!: number
    @Prop({ required: true }) carrierId!: number
    @Prop({ required: true }) formData!: { msisdn: string; provider: null|number }

    cardMinHeight = 0

    localLoading = false

    alreadyFilter = false

    exportLoading = false

    panelOpened: number|boolean = false

    dateFilter: string[][] = []

    lastPage: number|null = null

    tables = {
        subscriptionHistory: {
            data: [],
            columns: [
                {
                    text: 'ID',
                    value: 'subscriptionId'
                },
                {
                    text: 'MSISDN',
                    value: 'subscriptionMsisdn'
                },
                {
                    text: 'MDS',
                    value: 'mdsId'
                },
                {
                    text: 'Provider',
                    value: 'providerId.providerName'
                },
                {
                    text: 'Product',
                    value: 'productId.productName'
                },
                {
                    text: 'Shortcode',
                    value: 'shortcodeId.shortcode'
                },
                {
                    text: 'PIN',
                    value: 'pins'
                },
                {
                    text: 'Created At',
                    value: 'subscriptionCreatedAt'
                },
                {
                    text: 'Last Charge',
                    value: 'subscriptionLastChargeAt'
                },
                {
                    text: 'Next Charge',
                    value: 'subscriptionNextChargeAt'
                },
                {
                    text: 'Deactivated At',
                    value: 'subscriptionDeactivatedAt'
                },
                {
                    text: 'Deactivated By',
                    value: 'subscriptionDeactivatedBy'
                },
                {
                    text: 'Status',
                    value: 'subscriptionStatus'
                },
                {
                    text: 'Actions',
                    value: 'options'
                }
            ]
        }
    }

    subscriptionsHistory: { pagination: Pagination; filters: Filter[]; filterList: Filter[] } = {
        pagination: {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null,
            limit: 15
        },
        filters: [],
        filterList: [
            {
                text: 'Shortcode',
                type: 'select',
                value: 'shortcodeId',
                queryValue: '',
                values: []
            },
            {
                text: 'Product',
                type: 'select',
                value: 'productId',
                queryValue: '',
                values: []
            },
            {
                text: 'MDS ID',
                type: 'text',
                value: 'mdsId',
                queryValue: ''
            },
            {
                text: 'Subscription Status',
                type: 'select',
                value: 'subscriptionStatus',
                queryValue: '',
                values: [
                    {
                        text: 'Active',
                        value: 1
                    },
                    {
                        text: 'Inactive',
                        value: 0
                    }
                ]
            },
            {
                text: 'Deactivated By',
                type: 'text',
                value: 'subscriptionDeactivatedBy',
                queryValue: ''
            },
            {
                text: 'Created At',
                type: 'date',
                value: 'subscriptionCreatedAt',
                queryValue: []
            },
            {
                text: 'Last Charge',
                type: 'date',
                value: 'subscriptionLastChargeAt',
                queryValue: []
            },
            {
                text: 'Next Charge',
                type: 'date',
                value: 'subscriptionNextChargeAt',
                queryValue: []
            },
            {
                text: 'Deactivated At',
                type: 'date',
                value: 'subscriptionDeactivatedAt',
                queryValue: []
            }
        ]
    }

    @Watch('refreshTrigger')
    refreshHandler () {
        this.localLoading = true
        this.getSubscriptionsHistory()
        this.localLoading = false
    }

    // @Watch('subscriptionsHistory.filters')
    // onFiltersChange () {
    //     if (this.subscriptionsHistory.filters.length === 0) this.filterHandler()
    // }

    @Watch('panelOpened')
    onShow () {
        if (this.panelOpened === 0) this.refreshHandler()
        if (this.panelOpened === undefined) {
            this.subscriptionsHistory.filters = []
            this.dateFilter = []
        }
    }

    onPaginationChange (params: { page: number}) {
        if (params.page !== this.lastPage) this.getSubscriptionsHistory()
    }

    get unlockedFilters () {
        return this.subscriptionsHistory.filterList.filter((f: Filter) => !f.locked)
    }

    get lockedFilters () {
        return this.subscriptionsHistory.filterList.filter((f: Filter) => f.locked)
    }

    async mounted () {
        this.localLoading = true
        await this.getShortcodes()
        await this.getProducts()
    }

    getSubscriptionsHistory () {
        const table = document.querySelector('#sub-history')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (table) this.cardMinHeight = (table as any).offsetHeight

        this.lastPage = this.subscriptionsHistory.pagination.currentPage
        return new Promise(resolve => {
            this.localLoading = true

            let localProvider = JSON.parse(JSON.stringify(this.providerId))
            if (!Array.isArray(localProvider)) localProvider = localProvider ? [localProvider] : []

            this.subscriptionsHistory.filters.forEach((filter, i) => {
                if (filter.type === 'date') {
                    filter.queryValue = this.dateFilter[i]
                }
            })

            this.$store.dispatch('getSubscriptionsHistory', {
                filters: [
                    {
                        value: 'page',
                        queryValue: this.subscriptionsHistory.pagination.currentPage
                    },
                    {
                        value: 'limit',
                        queryValue: this.subscriptionsHistory.pagination.limit
                    },
                    {
                        value: 'carrierId',
                        queryValue: this.carrierId
                    },
                    {
                        value: 'providerId',
                        queryValue: localProvider
                    },
                    {
                        value: 'subscriptionMsisdn',
                        queryValue: this.formData.msisdn
                    },
                    ...this.subscriptionsHistory.filters
                ]
            })
                .then(resp => {
                    if (resp?.status === 200) {
                        this.subscriptionsHistory.pagination.total = resp.data.total

                        const subscriptions = this.$store.state.MonitorStore.subscriptionsHistory.results
                        this.tables.subscriptionHistory.data = subscriptions
                        this.localLoading = false
                        this.$emit('localLoadingEnd')

                        this.cardMinHeight = 0

                        if (table) {
                            window.scrollBy({
                                top: table.getBoundingClientRect().top - 100,
                                left: 0,
                                behavior: 'smooth'
                            })
                        }
                        resolve()
                    }
                })
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getBillSubscription (item: any) {
        return new Promise(resolve => {
            this.localLoading = true
            this.$store.dispatch('getBillSubscriptions', item.subscriptionId)
                .then(resp => {
                    if (resp?.status === 200) {
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement('a')

                        link.href = url

                        const contentDisposition = resp.headers['content-disposition']
                        let fileName = `subscription-statement-${item.subscriptionMsisdn}-${item.subscriptionId}.pdf`

                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/)
                            if (fileNameMatch && fileNameMatch.length > 1) {
                                fileName = fileNameMatch[1]
                            }
                        }

                        link.setAttribute('download', fileName)
                        document.body.appendChild(link)
                        link.click()

                        setTimeout(() => {
                            document.body.removeChild(link)
                            window.URL.revokeObjectURL(url)
                            this.localLoading = false
                            resolve('')
                        }, 100)
                    } else {
                        this.localLoading = false
                    }
                })
                .catch(error => {
                    this.localLoading = false
                    console.error('Error descargando PDF:', error)
                })
        })
    }

    getShortcodes () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorShortcodesFilter', { carrierId: this.carrierId, providerId: this.providerId })
                .then(resp => {
                    if (resp?.status === 200) {
                        resp.data.forEach((shortcode: {shortcodeId: number; shortcode: string}) => {
                            if (this.subscriptionsHistory?.filterList[0]?.values) {
                                this.subscriptionsHistory.filterList[0].values.push({
                                    text: shortcode.shortcode,
                                    value: shortcode.shortcodeId
                                })
                            }
                        })
                    }
                    resolve()
                })
        })
    }

    getProducts () {
        return new Promise(resolve => {
            this.$store.dispatch('getMonitorProductsFilter', { carrierId: this.carrierId, providerId: this.providerId })
                .then(resp => {
                    if (resp?.status === 200) {
                        resp.data.forEach((product: {productId: number; productName: string}) => {
                            if (this.subscriptionsHistory?.filterList[1]?.values) {
                                this.subscriptionsHistory.filterList[1].values.push({
                                    text: product.productName,
                                    value: product.productId
                                })
                            }
                        })
                    }
                    resolve()
                })
        })
    }

    newLimitHandler (limit: number) {
        this.subscriptionsHistory.pagination.limit = limit
        this.getSubscriptionsHistory()
    }

    addFilter () {
        this.subscriptionsHistory.filters.push(JSON.parse(JSON.stringify(this.subscriptionsHistory.filterList[0])))
        this.dateFilter.push([])
    }

    removeFilter (filterIndex: number) {
        this.subscriptionsHistory.filters = this.subscriptionsHistory.filters.filter((filter, index) => index !== filterIndex)
        this.dateFilter = this.dateFilter.filter((filter, index) => index !== filterIndex)
        this.$forceUpdate()
    }

    updateFilter (index: number, newFilter: string) {
        const foundFilter = this.subscriptionsHistory.filterList.find(filter => filter.value === newFilter)
        if (foundFilter) this.subscriptionsHistory.filters[index] = JSON.parse(JSON.stringify(foundFilter))
        this.$forceUpdate()
    }

    async filterHandler () {
        this.subscriptionsHistory.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null,
            limit: 15
        }
        this.getSubscriptionsHistory()
    }

    exportToCsv () {
        return new Promise(resolve => {
            this.exportLoading = true

            let localProvider = JSON.parse(JSON.stringify(this.providerId))
            if (!Array.isArray(localProvider)) localProvider = localProvider ? [localProvider] : []

            this.$store.dispatch('exportSubscriptionsHistory', {
                filters: [
                    {
                        value: 'page',
                        queryValue: this.subscriptionsHistory.pagination.currentPage
                    },
                    {
                        value: 'limit',
                        queryValue: this.subscriptionsHistory.pagination.limit
                    },
                    {
                        value: 'carrierId',
                        queryValue: 1
                    },
                    {
                        value: 'providerId',
                        queryValue: localProvider
                    },
                    {
                        value: 'subscriptionMsisdn',
                        queryValue: this.formData.msisdn
                    },
                    ...this.subscriptionsHistory.filters
                ]
            })
                .then(resp => {
                    this.exportLoading = false
                    if (resp.status === 200) {
                        const csvContent = 'data:text/csv;charset=utf-8,' + resp.data
                        const encodedUri = encodeURI(csvContent)
                        const link = document.createElement('a')

                        link.setAttribute('href', encodedUri)
                        link.setAttribute('download', `subscriptionHistory-${this.getDateFormat(new Date())}.csv`)
                        document.body.appendChild(link)
                        link.click()
                        resolve()
                    }
                })
        })
    }
}

